import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../ModalContainer/ModelContainer'
import Icon from '../../../Icons'
import DetailsItem from '../components/DetailsItem/DetailsItem'
import { mapEvidenceInfo, renderEvidence } from '../helpers'

const RewardsActivityEvidenceModal = ({
  onClose = () => {},
  onApprove = () => {},
  onDecline = () => {},
  activity,
}) => {
  const { t } = useTranslation(['rewards-loyalty'])
  const [photoIndexToDisplay, setPhotoIndexToDisplay] = useState(null)

  const onOpenImageModal = (index) => setPhotoIndexToDisplay(index)
  const { status, displayType } = activity
  const isPendingApproval = status === 'pending' || displayType === 'pending-approval'

  return (
    <ModalContainer
      additionalClass={'rewards-modal'}
      onClose={onClose}
      headerTitle={t('rewards-loyalty:evidence.activityCompletionEvidence')}
      headerIcon={<Icon icon="camera" />}
    >
      <div
        className="rewards-modal-content rewards-base-view activity-evidence"
        style={{ paddingBottom: isPendingApproval ? 0 : 20 }}
      >
        <DetailsItem data={mapEvidenceInfo(activity, t)} />
        <div className="rewards-modal-input-row">
          <div className="input-container">
            <div className="input-label">
              {t('rewards-loyalty:evidence.activityCompletionEvidence')}
            </div>
            {renderEvidence(activity, onOpenImageModal, photoIndexToDisplay, t)}
          </div>
        </div>
        {isPendingApproval && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <span className="alert-container">
                <Icon icon="exclamationPointTriangle" />
                {t('rewards-loyalty:evidence.pendingApprovalInfo')}
              </span>
            </div>
          </div>
        )}
      </div>
      {isPendingApproval && (
        <div className="rewards-modal-actions">
          <button className="button button-gray" onClick={onDecline}>
            {t('rewards-loyalty:loyaltyTable.declineButton')}
          </button>
          <button className="button button-primary" onClick={onApprove}>
            {t('rewards-loyalty:loyaltyTable.approveButton')}
          </button>
        </div>
      )}
    </ModalContainer>
  )
}

RewardsActivityEvidenceModal.propTypes = {
  onClose: PropTypes.func,
  activity: PropTypes.object,
  onApprove: PropTypes.func,
  onDecline: PropTypes.func,
}

export default RewardsActivityEvidenceModal
